import { useQuery } from '@tanstack/react-query'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getHotelViewCounter } from '../api/getHotelViewCounter'

export const useHotelViewCounter = () => {
	const location = useCartStore.use.location()

	return useQuery({
		queryKey: ['GET_HOTEL_INFO', location],
		queryFn: () => getHotelViewCounter(location!.hotelCode),
		enabled: Boolean(location),
		refetchInterval: 30000,
	})
}
